import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Hero from "./views/Hero";
import Kebablist from "./components/Kebablist";
import Kebabdetail from "./components/Kebabdetail";
import KebabAdd from "./components/KebabAdd";
import Impressum from "./views/impressum";
import Datenschutz from "./views/Datenschutz";
import '@fortawesome/fontawesome-free/css/all.min.css'

window.history.scrollRestoration = "manual";

function ScrollToAnchor() {
  const { pathname } = useLocation();
  useEffect(() => {
    const el = document.getElementById("reviews");
    if (el) el.scrollIntoView({ behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToAnchor />
      <Routes>
        <Route element={<Hero />}>
          <Route path="/" element={<Kebablist  />} />
          <Route path="/review/:id" element={<Kebabdetail/>} />
          <Route path="/add" element={<KebabAdd  />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Route>
      </Routes>
    </Router>
  )
}

export default App;
